import { DisciplinesFilterState } from './disciplines.types';

export const DISCIPLINE_ALL_OPTION = 'ALL';
export const getDefaultDisciplineFilter = (): DisciplinesFilterState => ({
  disciplines: { [DISCIPLINE_ALL_OPTION]: true },
});
export const defaultDisciplineFilter = getDefaultDisciplineFilter();
